"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_LANGUAGE = void 0;
exports["default"] = setLanguage;
var SET_LANGUAGE = 'WEB_CHAT/SET_LANGUAGE';
exports.SET_LANGUAGE = SET_LANGUAGE;
function setLanguage(language) {
  return {
    type: SET_LANGUAGE,
    payload: {
      language: language
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRVRfTEFOR1VBR0UiLCJleHBvcnRzIiwic2V0TGFuZ3VhZ2UiLCJsYW5ndWFnZSIsInR5cGUiLCJwYXlsb2FkIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FjdGlvbnMvc2V0TGFuZ3VhZ2UuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU0VUX0xBTkdVQUdFID0gJ1dFQl9DSEFUL1NFVF9MQU5HVUFHRSc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHNldExhbmd1YWdlKGxhbmd1YWdlKSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogU0VUX0xBTkdVQUdFLFxuICAgIHBheWxvYWQ6IHsgbGFuZ3VhZ2UgfVxuICB9O1xufVxuXG5leHBvcnQgeyBTRVRfTEFOR1VBR0UgfTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLFlBQVksR0FBRyx1QkFBdUI7QUFBQ0MsT0FBQSxDQUFBRCxZQUFBLEdBQUFBLFlBQUE7QUFFOUIsU0FBU0UsV0FBV0EsQ0FBQ0MsUUFBUSxFQUFFO0VBQzVDLE9BQU87SUFDTEMsSUFBSSxFQUFFSixZQUFZO0lBQ2xCSyxPQUFPLEVBQUU7TUFBRUYsUUFBUSxFQUFSQTtJQUFTO0VBQ3RCLENBQUM7QUFDSCJ9